import styled from 'styled-components'
import { breakpoints } from '../../../../constants'
import {
	BACKGROUND_FREE_SEAT,
	PRIMARY_LIGHT,
	LIGHTYELLOW,
	GRAY
} from '../../../../styles/colors.style'
import Button from '../../../../components/buttons/buttons.component'

export const StyledBannerContainer = styled.div`
	align-items: center;
	display: flex;
	flex-direction: column;
	@media screen and (min-width: ${breakpoints.MOBILE}px) {
		min-width: 400px;
	}
	.message {
		font-size: large;
		margin-bottom: 7px;
	}

	.insurance-image {
		max-width: 100%;
		display: block;
		@media screen and (min-width: ${breakpoints.MOBILE}px) {
		}
	}
`
export const StyledInsuranceModalContainer = styled.div`
	margin: 1rem 0;
	color: ${PRIMARY_LIGHT};
	text-align: center;
	line-height: 1.2;
	font-size: 2.5rem;
	.details {
		cursor: pointer;
		text-decoration: underline;
	}
`

export const StyledDenialModalContainer = styled.div`
	margin: 20px;
	text-align: center;
	line-height: 1.2;
	font-size: 2.5rem;
	text-align: left;

	> div:first-child {
		margin-bottom: 20px;

		div {
			> span {
				font-size: 18px;
				font-weight: bold;
			}

			ul {
				margin-top: 5px;

				li {
					font-size: 18px;
				}
			}
		}

		h1 {
			font-size: 32px;
		}

		p:last-child {
			font-weight: bold;
		}
	}

	a {
		position: absolute;
		font-size: 20px;
		bottom: 0;
		margin-bottom: 40px;
		text-decoration: underline;
	}
`

export const newWindow = (page, name, width, height, scroll) => {
	var leftPosition = screen.width ? (screen.width - width) / 2 : 0
	var topPosition = screen.height ? (screen.height - height) / 2 : 0
	var settings =
		'height=' +
		height +
		',width=' +
		width +
		',top=' +
		topPosition +
		',left=' +
		leftPosition +
		',scrollbars=' +
		scroll +
		',resizable'
	window.open(page, name, settings)
}

export const StyledBusContainer = styled.div`
	margin: 0 auto;

	@media screen and (min-width: ${breakpoints.MOBILE}px) {
		margin: initial;
	}
`

export const StyledResumeContainer = styled.div`
	margin-top: 2rem;
	max-width: 330px;

	@media screen and (min-width: ${breakpoints.MOBILE}px) {
		margin-left: 30px;
		margin-top: 0px;
	}
`

export const StyledButtonContainer = styled.div`
	display: flex;
	flex-direction: column-reverse;
	justify-content: space-between;
	button {
		padding: 1.8rem 3.5rem;
	}
	.continue-button {
		margin-bottom: 1.5rem;
	}

	@media screen and (min-width: ${breakpoints.MOBILE}px) {
		flex-direction: row;
		.continue-button {
			margin-bottom: initial;
		}
	}
`

export const StyledBusSeatLegend = styled.div`
	display: inline-flex;
	justify-content: space-around;
	margin: 10px 0px;

	@media screen and (min-width: ${breakpoints.MOBILE}px) {
		width: 320px;
	}

	.legend {
		align-items: center;
		display: flex;
		& > span {
			padding-left: 5px;
		}

		@media screen and (max-width: ${breakpoints.MOBILE}px) {
			margin-left: 10px;
		}
	}

	.free-seat,
	.selected-seat,
	.promotional-seat {
		border-radius: 5px;
		display: inline-block;
		height: 20px;
		width: 20px;
	}

	.free-seat {
		background: ${BACKGROUND_FREE_SEAT};
	}

	.selected-seat {
		background: ${PRIMARY_LIGHT};
	}

	.promotional-seat {
		background: ${LIGHTYELLOW};
	}
`

// Grade de colunas iguais: todas as abas de andar ficam com a largura da maior ("Superior"),
// independentemente do texto (spec 055, revisão visual ao vivo em 18/09).
export const StyledFloorSwitch = styled.div`
	display: grid;
	grid-auto-flow: column;
	grid-auto-columns: 1fr;
	gap: 10px;
	width: fit-content;
	margin: 0 auto 15px;

	button {
		padding: 0.8rem 2rem;
	}
`

export const StyledFloorButton = styled(Button)`
	${({ selected }) =>
		!selected &&
		`
			background: transparent;
			border: 1px solid ${GRAY};
			color: ${GRAY};
		`}
		font-weight: normal;
`

export const StyledContent = styled.div`
	display: flex;
	flex-direction: column;

	@media screen and (min-width: ${breakpoints.MOBILE}px) {
		flex-direction: row;
	}
`
